<template>
  <div>
    <div>
      <p v-if="minimum === 0">{{groupName}} is not a required section.</p>
      <p v-else>You are required to have at least {{minimum}} section(s) completed for {{groupName}}.</p>
      <p v-if="maximum">You may enter at most {{maximum}} sections for {{groupName}}.</p>
    </div>
    <div v-for="(group, grpIndex) in showing" v-bind:key="grpIndex">
      <div v-if="group.show">
        <br/>
        <div v-for="i in indexes" v-bind:key="i">
          <Question :qData="questions[i]" :started="group.started" :answer_increment="group.id" :multipleIndex="group.index" :categoryId="categoryId" />
        </div> 
        <button class="btn btn-primary btn-danger" @click="removeGroup(grpIndex)">Remove</button>
        <br/>
      </div>
      <div v-else>
        <br/>
        <div id="deletion_warning">
          <p>You have removed a {{groupName}}. <button class="btn btn-outline-danger restore" @click="restoreGroup(grpIndex)">Restore</button></p>
          <p>Once you hit save or navigate away from this category, it will be deleted.</p>
        </div>
        <br/>
      </div>
    </div>
    <br/>
    <button type="button" class="btn btn-primary" @click="addGroup()">+ Add {{groupName}}</button>
    <br/>
    <br/>
  </div>
</template>

<script>
import Question from './Question.vue'
export default {
  name:'category',
  props:{
    questions: Array,
    indexes: Array,
    started: Boolean,
    categoryId: Number
  },
  watch: { 
    questions: function() {
      this.setUpGroup()
    }
  },
  components:{
    Question
  },
  data(){
    return {
      minimum: null,
      maximum: null,
      groupName: null,
      showing: [],
      id_add_on: null,
      usedLetters: []
    }
  },
  mounted() {
    this.setMinimum()
    this.setMaximum()
    this.getGroupName()
    this.setUpGroup()

  },
  methods:{
    setMinimum(){
      this.minimum = this.$props.questions[this.$props.indexes[0]].validation.required.minimum
    },
    setMaximum(){
      if (this.$props.questions[this.$props.indexes[0]].validation.required.maximum) {
        this.maximum = this.$props.questions[this.$props.indexes[0]].validation.required.maximum
      }
    },
    getGroupName(){
      var name = this.$props.questions[this.$props.indexes[0]].repeat_group
      name = name.replace(/_/g, " ")
      name = name.split(" ")
      for (var i = 0, x = name.length; i < x; i++) {
        name[i] = name[i][0].toUpperCase() + name[i].substr(1)
      }
      this.groupName = name.join(" ")
    },
    setUpGroup(){
      this.showing = []
      this.usedLetters = []
      var answers = this.$props.questions[this.$props.indexes[0]].answer.value
      if (answers.length > 1) {
        //fill in showing and set the id_add_on value
        for (var a = 1; a < answers.length; a++) {
          
          var started = true
          started = this.checkIfStarted(a)

          //for every answer set that already exists, provide an index for value linking
          this.showing.push({show: true, id: answers[a].id[answers[a].id.length - 1], index: a, started: started})
          this.usedLetters.push(answers[a].id[answers[a].id.length - 1])

          
          if (Number(a) === (answers.length - 1)) { //if this is the last entry we have
            this.id_add_on = this.incrementLetter(answers[a].id[answers[a].id.length - 1])
          }
        }
      } else {
        this.id_add_on = "a"
        for (var i = 0; i < this.minimum; i++) {
          this.addGroup()
        }
      }
    },
    addGroup(){
      var count = 0
      for (var entry in this.showing) {
        if (this.showing[entry].show === true) {
          count++
        }
      }
      if (!this.maximum || (count < this.maximum))
      this.showing.push({show: true, id: this.id_add_on, started: false})
      this.id_add_on = this.incrementLetter(this.id_add_on)
    },
    removeGroup(grpIndex){
      this.$emit('removeQuestionGroup')
      var count = 0
      for (var entry in this.showing) {
        if (this.showing[entry].show === true) {
          count++
        }
      }
      if (count != this.minimum) {
        this.showing[grpIndex].show = false
      }
    },
    restoreGroup(grpIndex){
      this.showing[grpIndex].show = true
    },
    checkIfStarted(a) {
      var started = false
      for (var i in this.$props.indexes) {
        if (this.$props.questions[this.$props.indexes[i]].answer.value[a].value) {
          started = true
        }
      }
      return started
    },
    incrementLetter(a) {
      var letter = a
      do {
        if (letter == 'z') {
          //wrap around the alphabet
          letter = 'a'
        } else {
          //increment the letter
        letter = String.fromCharCode(letter.charCodeAt(0) + 1)
        }
      }
      while (this.usedLetters.includes(letter))
      return letter
    }
  }
}
</script>

<style lang="scss" scoped>

.btn-danger {
  color: #dc3545 !important;
  border: 2px solid #dc3545 !important;
}

.btn-danger:hover {
  color: #A52834 !important;
  border: 2px solid #A52834 !important;
}

#deletion_warning {
  background-color: #dc3545;
  color: white;
  border-radius: 10px;
  padding: 20px;
}

.restore {
  background-color: white;
  color: #dc3545;
}

.restore:hover {
  background-color: #ededed;
}

</style>

